import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { datadogRum } from '@datadog/browser-rum';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AppCanActivateGuard  {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
  ) {}

  public checkRoute() {
    if(this.authService.isAuthenticated()) {
      return true;
    } else {
      // Signed out without a logout (e.g. in another tab): stop session replay before
      // the login view starts, as logout would
      datadogRum.stopSessionReplayRecording();
      this.router.navigate(['/login']);
      return false;
    }

  }
  public canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {
    return this.checkRoute();
  }

  public canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {
    return this.checkRoute();
  }
}
